export default __webpack_public_path__ + "static/thumb-7-1c5435082f8258df4e31b6891a9e7e62.jpg";